import create from 'zustand';
import { persist } from 'zustand/middleware';

interface Coverage {
  code: string;
  sum_assured: string;
  name: string;
  deductive: number;
}

interface Receipts {
  number: number;
  start_date: string;
  end_date: string;
  net_premium: string;
  total_premium: string;
  right: string;
  recharge: string;
  tax: string;
  commission: string;
}

interface PaymentOptions {
  value: string;
  label: string;
}

  export interface Quote {
  insurance_premium: {
    tax: string;
    commission: string;
    net_premium: string;
    right: string;
    surcharge: string;
  };
  coverages_array: Coverage[];
  quote_id: string;
  company_logo: string;
  receipts: Receipts[];
  payment_options_json: PaymentOptions[];
  police_id: string;
}

interface QuoteStore {
  quoteList: Quote[] | [];
  quoteListReactQuery: Quote[] | [];
  isFetching: boolean;
  setIsFetching: (isFetching: boolean) => void;
  setQuoteList: (data: any[]) => void; 
}

interface SelectedQuoteStore {
  selectedQuote: any;
  setSelectedQuote: (selectedQuote: Quote) => void;
}

export const useQuoteStore = create<QuoteStore>((set, get) => ({
  quoteList: [],
  quoteListReactQuery: [],
  isFetching: false,
  setIsFetching: (isFetching: boolean) => {
    set({ isFetching });
  },
  setQuoteList: (data: any) => {
    set({ quoteList: data });
  },
}));
export const useSelectedQuoteStore = create<SelectedQuoteStore>(
  //@ts-ignore
  persist(
    (set) => ({
      selectedQuote: {},
      setSelectedQuote: (selectedQuote: Quote) => {
        set({ selectedQuote });
      },
    }),
    {
      name: 'quote-storage',
      getStorage: () => sessionStorage,
    }
  )
);
